import { Helmet } from "react-helmet-async";
import logo from "../images/LOGO.png";
import { SITE_NAME, SITE_ORIGIN, cmsSeo } from "../../data/cmsPublic";

export function CmsSeo({ document, kind, path, fallbackImage }) {
  const seo = cmsSeo(document || {}, { kind, path });
  const image = seo.image || fallbackImage || `${SITE_ORIGIN}${logo}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{seo.title}</title>
      {seo.description ? <meta name="description" content={seo.description} /> : null}
      {seo.keywords ? <meta name="keywords" content={seo.keywords} /> : null}
      <meta name="robots" content={seo.robots} />
      <meta name="author" content={seo.author} />
      <meta name="publisher" content={SITE_NAME} />
      <link rel="canonical" href={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      {seo.description ? (
        <meta property="og:description" content={seo.description} />
      ) : null}
      <meta property="og:locale" content="nb_NO" />
      <meta property="og:type" content={seo.ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={SITE_NAME} />
      {seo.published ? (
        <meta property="article:published_time" content={seo.published} />
      ) : null}
      {seo.modified ? (
        <meta property="article:modified_time" content={seo.modified} />
      ) : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      {seo.description ? (
        <meta name="twitter:description" content={seo.description} />
      ) : null}
      <script type="application/ld+json">{JSON.stringify(seo.jsonLd)}</script>
    </Helmet>
  );
}
